import Api from './api';

const MUNICIPAL_DISTRICTS_URL = '/municipal_districts';

export const getMunicipalDistrictsRequest = (params) => Api(
  { url: MUNICIPAL_DISTRICTS_URL, params },
  { isEntityAttributes: true },
);

export default getMunicipalDistrictsRequest;
